import { useParams } from 'react-router-dom';
import { PageHeader } from "@/components/ui/page-header";

const ConfigurationDetail = () => {
  const { id } = useParams();

  return (
    <div className="px-6 py-6 space-y-6">
      <PageHeader title="Configuration Details" />
      <p className="text-muted-foreground">Configuration ID: {id}</p>
      {/* Configuration details will be implemented later */}
    </div>
  );
};

export default ConfigurationDetail;